import { render, staticRenderFns } from "./OrganizationStepper.vue?vue&type=template&id=52075af6&scoped=true&"
import script from "./OrganizationStepper.vue?vue&type=script&lang=js&"
export * from "./OrganizationStepper.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStepper.vue?vue&type=style&index=0&id=52075af6&prod&scoped=true&lang=css&"
import style1 from "./OrganizationStepper.vue?vue&type=style&index=1&id=52075af6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52075af6",
  null
  
)

export default component.exports